import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { MarketingLayout } from '@/components/layout/MarketingLayout';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { cognitoResetPassword, mapCognitoErrorMessage } from '@/lib/cognito';
import { useToast } from '@/components/ui/use-toast';

export function ResetarSenha() {
  const [params] = useSearchParams();
  const [email, setEmail] = useState(params.get('email') ?? '');
  const [code, setCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    try {
      await cognitoResetPassword(email, code, newPassword);
      toast({ variant: 'success', title: 'Senha redefinida', description: 'Faça login com a nova senha.' });
      navigate('/login');
    } catch (err) {
      toast({ variant: 'danger', title: 'Falha', description: mapCognitoErrorMessage(err) });
    } finally {
      setLoading(false);
    }
  }

  return (
    <MarketingLayout>
      <div className="container-px mx-auto max-w-md py-16">
        <Card>
          <CardHeader>
            <CardTitle>Definir nova senha</CardTitle>
            <CardDescription>Use o código que enviamos pro seu email.</CardDescription>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5" />
              </div>
              <div>
                <Label htmlFor="code">Código (6 dígitos)</Label>
                <Input
                  id="code"
                  inputMode="numeric"
                  maxLength={6}
                  required
                  value={code}
                  onChange={(e) => setCode(e.target.value.replace(/\D/g, ''))}
                  className="mt-1.5 text-center tracking-widest"
                />
              </div>
              <div>
                <Label htmlFor="newPassword">Nova senha</Label>
                <Input
                  id="newPassword"
                  type="password"
                  autoComplete="new-password"
                  required
                  minLength={8}
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  className="mt-1.5"
                />
                <p className="text-xs text-muted-foreground mt-1">
                  Mínimo 8 caracteres, com maiúscula, minúscula e número.
                </p>
              </div>
              <Button type="submit" variant="accent" className="w-full" loading={loading}>
                Redefinir senha
              </Button>
            </form>
            <p className="mt-6 text-sm text-center">
              <Link to="/login" className="text-muted-foreground hover:text-foreground">
                Voltar ao login
              </Link>
            </p>
          </CardContent>
        </Card>
      </div>
    </MarketingLayout>
  );
}
